import { useContext } from 'react'

import { HomeContext } from '@provider/Shared/HomeProvider'

import { IHomeContext } from '@base/@types/providers/HomeProvider'

export default function useHome(): IHomeContext {
  const context = useContext(HomeContext)

  return context
}
